import React from 'react'
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom'
import AuthFacebook from './views/AuthFacebook'
import GuestOrLogin from './views/GuestOrLogin'
import Home from './views/Home'
import UserProvider from './contexts/user'
import IdProvider from './contexts/id'
import Success from './views/Success'
import Selfie from './components/Selfie'
import QueryParamHandler from './components/QueryParamHandler'
import AuthGoogle from './views/AuthGoogle'

function App() {
  return (
    <UserProvider>
      <IdProvider>
        <div className="bg-theme-default bg-cover h-screen w-screen">
          <Router>
            <QueryParamHandler />
            <Switch>
              <Route path="/auth/facebook">
                <AuthFacebook />
              </Route>
              <Route path="/auth/google">
                <AuthGoogle />
              </Route>
              <Route path="/home">
                <Home />
              </Route>
              <Route path="/selfie">
                <Selfie />
              </Route>
              <Route path="/success">
                <Success />
              </Route>
              <Route path="/">
                <GuestOrLogin />
              </Route>
            </Switch>
          </Router>
        </div>
      </IdProvider>
    </UserProvider>
  )
}

export default App
